const priceMixin = {
  methods: {
    addSymbol(price) {
      return (price === undefined || price === null) ? 'NA' : `₹ ${price}`
    }
  },
}

export default priceMixin
